
import { connect } from 'react-redux';
import OrderGrid from './order-grid';
import { selectOrderForDeliveryInfo, startPrintOrder, actionOnOrdercard, addOrderToRoute, removeOrderFromRoute, openRouteDialog, selectOrderForDeliveryTimeInfo, startCheckExportPossible } from '../../reducers/order.reducers';
import { openAlert } from '../../reducers/alert.reducers';
import { getVisibleOrders } from '../../reselect/order.selector';
import { registerScrollTopOrderGridFunction, setAlertSoundState } from '../../reducers/app.reducers';
import SmorderActions from '../../models/smorderActions';

const mapStateToProps = state => ({
  orders: getVisibleOrders(state),
  searchOrders: state.orders.orders,
  loading: state.orders.loading,
  orderSearchValue: state.orders.orderSearchValue,
  showTotalPrice: state.app.options && !!state.app.options.showTotalOrderPriceOnWaiterUI,
  printingorders: state.orders.printingorders,
  exportingOrders: state.orders.exportingOrders,
  isRoutePlanning: state.orders.routeplanning,
  routestops: state.orders.routestops,
  localSettings: state.app.localSettings,
  mainRef: state.app.orderGridMainRef,
});

const mapDispatchToProps = dispatch => ({
  proceedOrder: (order, description) => { dispatch(actionOnOrdercard({ order, proceeded: true, description })); },
  undoOrder: (order) => { dispatch(actionOnOrdercard({ order, proceeded: true, action: SmorderActions.Undo })); },
  declineOrder: order => dispatch(openAlert({
    title: 'Wirklich ablehnen?',
    message: 'Wollen sie diese Bestellung wirklich ablehnen?',
    onAgreeAction:
      actionOnOrdercard({ order, proceeded: false, description: 'Ablehnen' }),
    onDismissAction: null,
    isOrderDeclineAlert: true,
  })),
  playSound: () => {
    dispatch(setAlertSoundState(false));
    dispatch(setAlertSoundState(true));
  },
  openDeliveryDialog: order => dispatch(selectOrderForDeliveryInfo(order)),
  printOrder: order => dispatch(startPrintOrder(order)),
  exportOrder: order => dispatch(startCheckExportPossible(order)),
  addOrderToRoute: order => dispatch(addOrderToRoute(order)),
  removeOrderFromRoute: order => dispatch(removeOrderFromRoute(order)),
  openRouteDialog: () => dispatch(openRouteDialog()),
  registerScrollTopOrderGridFunction: scrollFunction => dispatch(registerScrollTopOrderGridFunction(scrollFunction)),
  selectOrderForDeliveryTimeInfo: order => dispatch(selectOrderForDeliveryTimeInfo(order)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderGrid);
